module.exports = __webpack_public_path__ + "static/media/open-quote.21a3d264.svg";